export default __webpack_public_path__ + "static/media/reff_code_red.73ae9f17.svg";